import { FAQPageJsonLd } from 'next-seo';
import { faqs } from './nameIdeasContent';

export default function Faq() {
  return (
    <>
      <FAQPageJsonLd mainEntity={faqs} />
      <section className="tw-py-10 tw-bg-gray-50 sm:tw-py-16 lg:tw-py-24">
        <div className="tw-max-w-6xl tw-px-4 tw-mx-auto sm:tw-px-6 lg:tw-px-8">
          <h2 className="tw-text-3xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-4xl lg:tw-text-5xl">
            Frequently Asked Questions
          </h2>

          <div className="tw-flow-root">
            <div className="tw-divide-y tw-divide-gray-200">
              {faqs.map(faq => {
                return (
                  <div className="tw-py-9" key={faq.questionName}>
                    <h3 className="tw-m-0 tw-text-xl tw-font-semibold tw-text-gray-900">
                      {faq.questionName}
                    </h3>
                    <p className="tw-mb-0 tw-mt-3 tw-text-base tw-text-gray-600">
                      {faq.acceptedAnswerText}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
